<template>
  <div :class="[b(),className]"
       :style="styleSizeName">
    <div :ref="id"
         :style="styleChartName"></div>
  </div>
</template>

<script>
import create from "../../create";

export default create({
  name: "scatter",//散点图
  methods: {
    updateChart() {
      const optionData = this.deepClone(this.dataChart);
      const option = {
        title: this.getOptionTitle(),
        tooltip: this.getOptionTip(),
        grid: this.getOptionGrid(),
        xAxis: this.getXAxisOption(),
        yAxis: this.getYAxisOption(),
        series: (() => {
          const barColor = this.option.barColor || [];
          let list = (optionData || []).map((ele, index) => {
            return Object.assign(ele, {
              type: "scatter",
              symbolSize: this.option.symbolSize || 10,
              itemStyle: {
                color: this.getColor(index)
              },
              label: this.getOptionLabel()
            });
          });
          if (this.isDataCenter) {
            let _op = this.getDimentionOption()
            list = _op.series.map((el, index) => {
              return {
                type: "scatter",
                symbolSize: this.option.symbolSize || 10,
                itemStyle: {
                  color: this.getColor(index)
                },
                label: this.getOptionLabel(),
                name: el.name,
                data: this.dataChart.map((_el) => [_el[this.dcode], _el[this.mcode]])
              }
            })
          }
          return list;
        })()
      };
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    }
  }
});
</script>

